import type { Margins, SpatialRectangle } from "#public"
import type { Measure } from "#public"

import { AddMargins } from "./AddMargins"

/** Pull each edge of a rect in by its margin — {@link AddMargins} reversed. */
export const RemoveMargins = <T extends Measure>(
  rect: SpatialRectangle<T>,
  margins: T | Margins<T> = 0 as T
): SpatialRectangle<T> => AddMargins(rect, margins, -1)
